module.exports = __webpack_public_path__ + "assets/img/wa-origeshiki.e841f727.svg";